<template>
  <Teleport to="body">
    <transition name="slide-right">
      <div v-if="modelValue" class="instruction-overlay" :style="{ zIndex }">
        <q-card class="instruction-card">
          <q-card-section class="q-pb-none">
            <div class="row items-center no-wrap">
              <div class="text-blue-brand text-bold">{{ title }}</div>
              <q-space />
              <q-btn
                flat
                round
                dense
                icon="close"
                @click="$emit('update:modelValue', false)"
              />
            </div>
          </q-card-section>
          <q-card-section class="text-center">
            <div class="instruction-icon q-mb-sm">
              <q-icon :name="icon" size="64px" color="blue-brand" />
            </div>
            <div class="text-body1">{{ message }}</div>
          </q-card-section>
          <q-card-section v-if="tip" class="q-pt-none">
            <div class="row items-start no-wrap text-caption text-grey-7">
              <q-icon
                name="lightbulb"
                size="18px"
                class="q-mr-xs"
                color="amber-8"
              />
              <div>
                <span>{{ tip }}</span>
                <a
                  v-if="tipActionLabel"
                  href="#"
                  class="tip-action-link"
                  @click.prevent="$emit('tip-action')"
                  >{{ tipActionLabel }}</a
                >
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="actionLabel" class="q-pt-none text-center">
            <q-btn
              flat
              no-caps
              color="primary"
              :icon="actionIcon"
              :label="actionLabel"
              @click="$emit('action')"
            />
          </q-card-section>
        </q-card>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InstructionCard',
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, required: true },
    icon: { type: String, required: true },
    message: { type: String, required: true },
    tip: { type: String, default: '' },
    tipActionLabel: { type: String, default: '' },
    actionLabel: { type: String, default: '' },
    actionIcon: { type: String, default: '' },
    // Default sits at Quasar's modal layer. Callers that render the card
    // alongside an open q-dialog should bump this above 6000 so the card
    // remains interactive (e.g. 7000).
    zIndex: { type: Number, default: 6000 },
  },
  emits: ['update:modelValue', 'action', 'tip-action'],
});
</script>

<style scoped>
.instruction-overlay {
  position: fixed;
  top: 80px;
  right: 16px;
  width: 300px;
}

.instruction-card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.tip-action-link {
  display: inline;
  margin-left: 4px;
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.instruction-icon {
  animation: pulse-icon 2s ease-in-out infinite;
}

@keyframes pulse-icon {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.7;
  }
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(120%);
  opacity: 0;
}

.slide-right-enter-to,
.slide-right-leave-from {
  transform: translateX(0);
  opacity: 1;
}
</style>
